import classesData from '@/data/classes.json';

export interface CatalogSeasonFlags {
  offeredFall: boolean;
  offeredSpring: boolean;
  offeredSummer: boolean;
  offeredWinter: boolean;
}

type ClassesRow = {
  offeredFall?: boolean;
  offeredSpring?: boolean;
  offeredSummer?: boolean;
  offeredWinter?: boolean;
};

/**
 * Looks up merged SOC/catalog season flags from data/classes.json by 8-digit base id.
 */
export function getCatalogSeasonFlags(baseId: string): CatalogSeasonFlags | null {
  const digits = baseId.replace(/\D/g, '');
  if (digits.length !== 8) return null;
  const row = (classesData as Record<string, ClassesRow>)[digits];
  if (!row) return null;
  if (
    typeof row.offeredFall !== 'boolean' ||
    typeof row.offeredSpring !== 'boolean' ||
    typeof row.offeredSummer !== 'boolean' ||
    typeof row.offeredWinter !== 'boolean'
  ) {
    return null;
  }
  return {
    offeredFall: row.offeredFall,
    offeredSpring: row.offeredSpring,
    offeredSummer: row.offeredSummer,
    offeredWinter: row.offeredWinter,
  };
}

export function catalogHasAnySeason(flags: CatalogSeasonFlags): boolean {
  return flags.offeredFall || flags.offeredSpring || flags.offeredSummer || flags.offeredWinter;
}

/** Same seasons as legacy CSV, keyed by 8-digit base id — for degree tools / planning checks. */
export type FlatSeasonAvailability = {
  fall: boolean;
  spring: boolean;
  winter: boolean;
  summer: boolean;
};

let catalogAvailabilityMap: Map<string, FlatSeasonAvailability> | null = null;

export function getCatalogAvailabilityMap(): Map<string, FlatSeasonAvailability> {
  if (catalogAvailabilityMap) return catalogAvailabilityMap;
  catalogAvailabilityMap = new Map();
  const data = classesData as Record<string, ClassesRow>;
  for (const [id, row] of Object.entries(data)) {
    if (
      id.length !== 8 ||
      typeof row.offeredFall !== 'boolean' ||
      typeof row.offeredSpring !== 'boolean' ||
      typeof row.offeredSummer !== 'boolean' ||
      typeof row.offeredWinter !== 'boolean'
    ) {
      continue;
    }
    catalogAvailabilityMap.set(id, {
      fall: row.offeredFall,
      spring: row.offeredSpring,
      winter: row.offeredWinter,
      summer: row.offeredSummer,
    });
  }
  return catalogAvailabilityMap;
}
